/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toPutRoomRequest, toRoomProps, toRoomRequest } from './translator/room'
import { toDoctorProps } from './translator/doctor'
import { toRoomTalkerProps } from './translator/talker'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import {
  FetchRoom,
  PostRoom,
  FetchRoomGroups,
  FetchRoomDoctors,
  FetchRoomTalkers,
  GetRoom,
  DeleteRoom,
  PutRoom
} from '@/infrastructure/network/Monitaro/requests/room'
import { IRoomProps } from '@/entities/Room'

export default class Room extends MonitaroGatewayBase {
  async FetchRoom(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchRoom(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.rooms.map((prop) => toRoomProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async PostRoom(params: IRoomProps) {
    const { room } = await this.apiClient.request(new PostRoom(toRoomRequest(params)))
    return toRoomProps(room)
  }

  async FetchRoomGroups(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchRoomGroups(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.rooms.map((prop) => toRoomProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async FetchRoomDoctors(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchRoomDoctors(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.doctors.map((prop) => toDoctorProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async FetchRoomTalkers(room: string, query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchRoomTalkers(room, toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.talkers.map((prop) => toRoomTalkerProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async GetRoom(id: string) {
    const { room } = await this.apiClient.request(new GetRoom(id))
    return toRoomProps(room)
  }

  async DeleteRoom(id: string) {
    const { room } = await this.apiClient.request(new DeleteRoom(id))
    return toRoomProps(room)
  }

  async PutRoom(id: string, props: IRoomProps) {
    const { room } = await this.apiClient.request(new PutRoom(id, toPutRoomRequest(props)))
    return toRoomProps(room)
  }
}
